import type {RuleValidationErrors} from '../types';
import type {FileFormatFamilyRule} from './types';

export const validateFileFormatFamily = <
	T extends FileFormatFamilyRule = FileFormatFamilyRule,
>(
	rule: T,
): RuleValidationErrors | false => {
	return false;
};

export default validateFileFormatFamily;
